<template>
    <b-modal
        id="add-peers-modal"
        v-model="model"
        modal-class="apprentice-default-modal rubric-survey-add-peers"
        :title="$t('rubrics.add_students')"
        size="lg"
        ok-only
        :ok-title="$t('common.close')"
        cancel-variant="outline-primary">
        <design-2021-apprentice-data-table
            class="selected-survey-peers-table"
            :items="peers"
            :fields="fields"
            nosearch
            :show-empty="true">
            <template
                v-slot:options
                v-if="rubricUserIn.peers.length < rubricConsumer.peer_amount">
                <design-2021-apprentice-select-search-component
                    class="students-peers-select"
                    :selected-in="selectedUser"
                    label="full_name"
                    :multiple="false"
                    :max="rubricConsumer.peer_amount"
                    :options="availableUsers"
                    :placeholder="$t('rubrics.choose_a_student')"
                    :trackBy="'full_name'"
                    :close-on-select="false"
                    @input="updated">
                </design-2021-apprentice-select-search-component>

                <b-button
                    class="btn-add btn-add-survey-user-peer"
                    variant="primary"
                    @click="addPeer"
                    :disabled="!selectedUser">
                    {{ $t('rubrics.add_peer') }}
                </b-button>
            </template>

            <template v-slot:cell(date)="data">
                {{ data.item.created_at | date_time_om_year }}
            </template>

            <template #empty="scope">
                <div class="not-found with-header empty-student-peers-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('rubrics.no_students_selected') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-peer-invite-modal-component',
    props: ['rubricUserIn', 'rubricTypeIn'],
    data() {
        return {
            users: [],
            user_loaded: false,
            model: false,
            peers: this.rubricUserIn.peers,
            selectedUser: null,
            fields: [
                {
                    key: 'user.full_name',
                    label: this.$t('rubrics.student'),
                    sortable: true,
                },
                {
                    key: 'date',
                    label: this.$t('rubrics.date'),
                    sortable: true,
                },
            ],
        };
    },

    computed: {
        availableUsers() {
            if (this.peers) {
            }
            const peer_ids = this.peers.map((peer) => peer.user_id);
            return this.users.filter((user) => !peer_ids.includes(user.id) && user.id !== this.rubricUserIn.user_id);
        },
        rubricConsumer() {
            switch (this.rubricTypeIn) {
                case 'rubricSurvey':
                    return this.rubricUserIn.rubric_survey;
                case 'assignmentRubric':
                    return this.rubricUserIn.assignment_rubric;
            }
        },
    },

    methods: {
        show() {
            this.selectedUser = null;
            this.axios.get(this.routes.getRubricUserPotentialPeers(this.rubricUserIn.id, this.rubricTypeIn)).then(
                (response) => {
                    this.users = response.data;
                    this.user_loaded = true;
                    this.model = true;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updated(checked) {
            if (checked) {
                this.selectedUser = checked;
            }
        },

        addPeer() {
            if (!this.selectedUser) {
                return;
            }

            let data = {
                rubric_user_id: this.rubricUserIn.id,
                rubric_type: this.rubricTypeIn,
                user_id: [this.selectedUser.id],
            };

            this.alert.saving();
            this.axios.post(this.routes.rubricSurveyUserPeerStore(), data).then(
                (response) => {
                    this.peers.push(...response.data);
                    this.selectedUser = null;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.selected-survey-peers-table ::v-deep {
    .apprentice-table-header {
        .options {
            column-gap: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.btn-add-survey-user-peer {
    display: flex;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'eight');
}

.apprentice-search-select {
    width: 350px;
}
</style>
